import * as React from 'react';
import { GridCell } from '@progress/kendo-react-grid';
import { Button } from '@material-ui/core';
import { getStatus } from 'src/effects/utils/common';


export default class ActiveInactiveUserButto extends GridCell {
    constructor(props: any) {
        super(props);
    }
    render() {
        return (
            <td>
                <Button type="button" className={getStatus(this.props.dataItem.isActiveStatusText)} variant="outlined">{this.props.dataItem.isActiveStatusText}</Button>
            </td>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/users/ActiveInactiveUserButton.tsx